export default __webpack_public_path__ + "static/media/icon_question.435ba737.svg";